import InputField from "components/shared/input-field/InputField";
import PropTypes from "prop-types";
import { useContext, useState } from "react";
import Modal from "react-modal";
import GuiContext from "../../config/context/guiContext";
import useCustomStyles from "../../config/useCustomStyles";
import useTheme from "../../config/useTheme";
import styles from "../../css/privateKey.module.css";
import Button from "../shared/button/Button";

const AddNewServer = ({ typeCall, openModal, setOpenModal }) => {
  const [firstInput, addFirstInput] = useState("");
  const [lastInput, addLastInput] = useState("");
  const [serverMessage, setServerMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const { dark } = useTheme();
  const { userData, updateServers, removeServer, URL, selected: {selectedServer} } = useContext(GuiContext);
  const customStyles = useCustomStyles();
  const handleCancel = () => {
    addFirstInput("");
    addLastInput("");
    setServerMessage("");
    setOpenModal(false);
  };
  const resetForm = () => {
    addFirstInput("");
    addLastInput("");
  };
  const handleSubmit = () => {
    const url = `${URL}/api/inerygui/${typeCall}`;
    const data = {
      guiname: userData.guiname,
      server_url: selectedServer,
      new_server_url: firstInput,
      pincode: lastInput,
    };

    async function sendDataToServer() {
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
        const res = await response.json();
        if (response.ok) {
          typeCall === "add_server"
            ? updateServers(firstInput)
            : removeServer(firstInput);
          setSuccess(true);
          setServerMessage(res.message);
          resetForm();
        } else {
          setSuccess(false);
          setServerMessage(
            typeCall === "add_server"
              ? "Inery Node URL not working"
              : "Unable to remove server",
          );
        }
      } catch (error) {
        console.error(error);
      }
    }
    sendDataToServer();
  };

  if (typeCall === "add_server") {
    return (
      <Modal
        isOpen={openModal}
        ariaHideApp={false}
        // onAfterOpen={afterOpenModal}
        // onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Modal"
      >
        <div
          className={`${styles.privateKey} ${
            dark ? styles.dark : ""
          } container`}
        >
          <h2>Add server</h2>
          <div className="container column gap-1">
            <InputField
              value={firstInput}
              onChange={(e) => addFirstInput(e.target.value)}
              type="text"
              placeholder="Enter server url"
            />
            <InputField
              value={lastInput}
              onChange={(e) => addLastInput(e.target.value)}
              type="password"
              placeholder="Enter your pincode"
            />
          </div>
          <div className="container column align-center gap-1">
            <Button onClick={handleSubmit} expand="full">
              Add new Server
            </Button>
            <Button
              onClick={handleCancel}
              buttonType="text"
              variant="secondary"
            >
              Cancel
            </Button>
          </div>
          {serverMessage && (
            <p className={success ? styles.success : styles.error}>
              {serverMessage}
            </p>
          )}
        </div>
      </Modal>
    );
  }

  if (typeCall === "remove_server") {
    return (
      <Modal
        isOpen={openModal}
        ariaHideApp={false}
        // onAfterOpen={afterOpenModal}
        // onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Modal"
      >
        <div className={`${styles.privateKey} ${dark ? styles.dark : ""}`}>
          <div className={styles.text}>
            <h2>Remove server</h2>
          </div>
          <input
            value={firstInput}
            onChange={(e) => addFirstInput(e.target.value)}
            type="text"
            placeholder="Enter server url"
          />
          <input
            value={lastInput}
            onChange={(e) => addLastInput(e.target.value)}
            type="password"
            placeholder="Enter your pincode"
          />
          <div className={styles.btnGroup}>
            <Button onClick={handleSubmit} text="Remove Server" >Remove Server</Button>
            <Button onClick={handleCancel} text="Cancel" >Cancel</Button>
          </div>
          {serverMessage && (
            <p className={success ? styles.success : styles.error}>
              {serverMessage}
            </p>
          )}
        </div>
      </Modal>
    );
  } else {
    return null;
  }
};

export default AddNewServer;

AddNewServer.propTypes = {
  type: PropTypes.string,
  typeCall: PropTypes.string,
};
